import Grid from './Grid'
import GridColumn from './GridColumn'

Grid.Column = GridColumn

export default Grid
